import * as Sentry from '@sentry/vue'
import { ApiError } from '@/api'

// The answers that are the user's own doing or an expected state, not a fault: 401 is the session (`stores/auth.ts` owns it),
// 403/409 a list or action that is not allowed (read-only list) and 422 a validation message.
const EXPECTED_STATUSES = [401, 403, 409, 422]

// For errors that are caught and shown to the user (an inline red text or a toast), as Sentry's Vue integration only sees uncaught ones.
// `context` says where it was shown, normally the i18n key of the message. A no-op when Sentry is not initialised.
export function reportError(e: unknown, context: string): void {
  if (e instanceof ApiError) {
    if (EXPECTED_STATUSES.includes(e.status)) return
    Sentry.captureException(e, { tags: { ui_error: context }, extra: { status: e.status } })
    return
  }
  Sentry.captureException(e, { tags: { ui_error: context } })
}
